import React, { useRef } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Name, Title, Info, Code, Actions, Toast,  API, Utility, Button, Files, Control, Messages, OptionType } from 'helpers/PrintImports';
import { Exam } from "models/ExamModel";
import { User } from 'models/UserModel';
import { Doctor } from 'models/DoctorModel';
import { Client } from 'models/ClientModel';
import { Term } from 'models/TermModel';
import { PrescriptionData, MedicationData, CommonDataColumn } from 'models/BaseModel';
import { mapMedication, mapRxData } from 'helpers/forms/ExamHelper';

const ExamPrint: React.FC = () => {
  const width = { product: 42, price: 12, qty: 10, discount: 12, gst: 12, Amount: 12 }
  const width2 = { date: 16, receivedfrom: 30, mop: 18, receivedby: 20, amount: 16 }
  const [formId, formName] = [Code.Form.Id.EXAM, Code.Form.Name.EXAM];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [formData, setFormData] = useState<Exam>({});
  const [clientData, setClientData] = useState<Client | null>(null);
  const [doctorData, setDoctorData] = useState<Doctor | null>(null);
  const [userData, setUserData] = useState<User | null>(null);
  const [examData, setExamData] = useState<CommonDataColumn | null>(null);
  const [finalRx1, setFinalRx1] = useState<PrescriptionData | null>(null);
  const [finalRx2, setFinalRx2] = useState<PrescriptionData | null>(null);
  const [finalRx3, setFinalRx3] = useState<PrescriptionData | null>(null);
  const [medication, setMedication] = useState<MedicationData | null>(null);
  const [clTrial1, setClTrial1] = useState<PrescriptionData | null>(null);
  const [clTrial2, setClTrial2] = useState<PrescriptionData | null>(null);
  const [clTrial3, setClTrial3] = useState<PrescriptionData | null>(null);
  const [clFinal, setClFinal] = useState<PrescriptionData | null>(null);
  const [tableDataFinalRx1, setTableDataFinalRx1] = useState<boolean>(true);
  const [tableDataFinalRx2, setTableDataFinalRx2] = useState<boolean>(false);
  const [tableDataFinalRx3, setTableDataFinalRx3] = useState<boolean>(false);
  const [tableDataMedication, setTableDataMedication] = useState<boolean>(false);
  const [tableDataCLTrial1, setTableDataCLTrial1] = useState<boolean>(false);
  const [tableDataCLTrial2, setTableDataCLTrial2] = useState<boolean>(false);
  const [tableDataCLTrial3, setTableDataCLTrial3] = useState<boolean>(false);
  const [tableDataCLFinal, setTableDataCLFinal] = useState<boolean>(false);
  const [expiryDate, setExpiryDate] = useState<Date>(new Date());
  const [fieldDispenser, setFieldDispenser] = useState<boolean>(false);
  const [fieldClientId, setFieldClientId] = useState<boolean>(true);
  const [fieldAHC, setFieldAHC] = useState<boolean>(false);
  const [fieldDOB, setFieldDOB] = useState<boolean>(true);
  const [fieldPhone, setFieldPhone] = useState<boolean>(true);
  const [fieldAddress, setFieldAddress] = useState<boolean>(true);
  const [termData, setTermData] = useState<string>(Code.Term.PRESCRIPTION);
  const [termList, setTermList] = useState<Term[]>([]);  

  const [searchParams] = useSearchParams();
  const dataId = searchParams.get('data');

  Form.Click.Outside([contextMenuRef],[() => setShowMenu(false),() => {}],true);
  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    API.Data.GetByKeyId<Exam>(formName, keyId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setFormData((prevData) => ({
        ...prevData,
        ...formData,
      }));

      const fieldName = `${Name.Exam.Data}${dataId}`;
      const tempExamData = (data as any)[fieldName];

      setExamData(await Files.List.extractCommonData(Utility.Convert.decodeHTML(tempExamData)));
      setClientData(await API.Data.GetClientCity(data.client_id));
      setDoctorData(await API.Data.GetDoctor(data.doctor_id));
      setUserData(await API.Data.GetUser(data.user_id));
      callTermList(data.location_id);
    }})
    setLoading(false);
  }, []); 

  const callTermList = async (locationId: number | undefined) => {
    if (!locationId) return;  
      const url = API.Build.FormApiEndpint(Code.Form.Name.TERM, 0, Name.Term.Id, Code.Option.Sort.DESC, {
      fields: Utility.Join.Fields([Name.Term.Date, Name.Term.Name, Name.Term.Comment]),
      [Name.Location.Id]: locationId,
      [Name.Form.Id]: 198, //priscription
    });
    await API.Data.List<Term>(url, setTermList, setError, setLoading);
  };

  useEffect(() => { 
    if(termList && termList.length>0) {
      var terms = termList[0].term_comment || '';
      if(terms.length>0){
        setTermData(terms)
      }
    }
  }, [termList]); 

  useEffect(() => { 
    if(examData){
      let finalRx1 = false;
      let finalRx2 = false;
      let finalRx3 = false;
      let finalCL = false;
      let finalCLTrial1 = false;
      let finalCLTrial2 = false;
      let finalCLTrial3 = false;
      if (examData.R67 || examData.L67 || examData.R68 || examData.L68 || examData.R69 || examData.L69) {
        finalRx1 = true;
      } else if (examData.R206 || examData.L206 || examData.R207 || examData.L207 || examData.R208 || examData.L208) {
        finalRx2 = true;
      } else if (examData.R240 || examData.L240 || examData.R241 || examData.L241 || examData.R242 || examData.L242) {
        finalRx3 = true;
      } else if (examData.R191 || examData.L191 || examData.R192 || examData.L192 || examData.R193 || examData.L193) {
        finalCL = true;
      } else if (examData.R162 || examData.L162 || examData.R163 || examData.L163 || examData.R164 || examData.L164) {
        finalCLTrial1 = true;
      } else if (examData.R181 || examData.L181 || examData.R182 || examData.L182 || examData.R183 || examData.L183) {
        finalCLTrial2 = true;
      } else if (examData.R267 || examData.L267 || examData.R268 || examData.L268 || examData.R269 || examData.L269) {
        finalCLTrial3 = true;
      }else {
        console.log('neither branch matched');
      }

      MapFinalRx1(finalRx1);  
      MapFinalRx2(finalRx2);  
      MapFinalRx3(finalRx3);  
      MapCLFinal(finalCL);  
      MapCLTrial1(finalCLTrial1);  
      MapCLTrial2(finalCLTrial2);  
      MapCLTrial3(finalCLTrial3);  

      if(!finalRx1 && !finalRx2 && !finalRx3 && !finalCL && !finalCLTrial1 && !finalCLTrial2 && !finalCLTrial3) {
        MapFinalRx1(true);
      }

    }
  }, [examData]); 

  useEffect(() => { 
    if (clientData && formData && examData) {
      let addYears = 0;
      let ageNumber = 2;
      const examType = formData.type_id;
      if (examType && examType > 0) {
        // if (examType == 10 || examType == 11 || examType == 12) {
        //   addYears = 1;
        // } else { 
          
        // }
        ageNumber = Utility.Format.AgeYear2(clientData.client_dob);
        
        //console.log('ageNumber---->',ageNumber);
        

        if (ageNumber >= 19 && ageNumber <= 65) {
          if(companyId==10) //care inc
            addYears = 2;
          else 
            addYears = 1;
        } else {
          addYears = 1;
        }

        let newDate = DateUtility.AddYears(formData.exam_date, addYears);

        try{
            if(examData.D68){
            const parsed = new Date(`${examData.D68} 10:00:00`);
            if (!isNaN(parsed.getTime())) {
              newDate = parsed;
            }
          }
        } catch {
          //do nothing
        }
        
        
        if (newDate) setExpiryDate(newDate);
      }
    }
  }, [clientData]); 

  class DateUtility {
    static AddYears(date: Date | undefined, years: number): Date | null {
      if (!date) return null;
      
      const newDate = new Date(date);
      newDate.setFullYear(newDate.getFullYear() + years);
      return newDate;
    }
  }

  const handleCheckChange = (e: React.ChangeEvent<HTMLInputElement>, rxId: number) => {
    if(rxId===Code.Exam.Map.FINALRX) MapFinalRx1(e.target.checked);
    else if(rxId===Code.Exam.Map.FINALRX2) MapFinalRx2(e.target.checked); 
    else if(rxId===Code.Exam.Map.FINALRX3) MapFinalRx3(e.target.checked); 
    else if(rxId===Code.Exam.Map.MEDICATION) MapMedication(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLTRAIL1) MapCLTrial1(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLTRAIL2) MapCLTrial2(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLTRAIL3) MapCLTrial3(e.target.checked); 
    else if(rxId===Code.Exam.Map.CLFINAL) MapCLFinal(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_AHC) setFieldAHC(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_DOB) setFieldDOB(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_PHONE) setFieldPhone(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_ADDRESS) setFieldAddress(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_CLIENT_ID) setFieldClientId(e.target.checked); 
    else if(rxId===Code.Exam.Map.FIELD_DISPENSER) setFieldDispenser(e.target.checked); 
  };

  const MapFinalRx1 = (checked: boolean) => {
      setTableDataFinalRx1(checked);
      if (checked) {
        const finalRx = mapRxData(examData, Number(Code.Exam.Map.FINALRX));
        setFinalRx1(finalRx);
      } else setFinalRx1({}); 
  };

  const MapFinalRx2 = (checked: boolean) => {
      setTableDataFinalRx2(checked);
      if (checked) {
        const finalRx2 = mapRxData(examData, Number(Code.Exam.Map.FINALRX2));
        setFinalRx2(finalRx2);
      } else setFinalRx2({});
  };

  const MapFinalRx3 = (checked: boolean) => {
      setTableDataFinalRx3(checked);
      if (checked) {
        const finalRx3 = mapRxData(examData, Number(Code.Exam.Map.FINALRX3));
        setFinalRx3(finalRx3);
      } else setFinalRx3({});
  };

  const MapMedication = (checked: boolean) => {
      setTableDataMedication(checked);
      if (checked) {
        const Medication = mapMedication(examData);
        setMedication(Medication);
      } else setMedication({});
  };

  const MapCLTrial1 = (checked: boolean) => {
      setTableDataCLTrial1(checked);
      if(checked) { 
        const CLTrail1 = mapRxData(examData, Number(Code.Exam.Map.CLTRAIL1)); 
        setClTrial1(CLTrail1);
      } else { setClTrial1({});}
  };

  const MapCLTrial2 = (checked: boolean) => {
      setTableDataCLTrial2(checked);
      if(checked) { 
        const CLTrail2 = mapRxData(examData, Number(Code.Exam.Map.CLTRAIL2)); 
        setClTrial2(CLTrail2);
      } else { setClTrial2({});}
  };

  const MapCLTrial3 = (checked: boolean) => {
      setTableDataCLTrial3(checked);
      if(checked) { 
        const CLTrail3 = mapRxData(examData, Number(Code.Exam.Map.CLTRAIL3)); 
        setClTrial3(CLTrail3);
      } else { setClTrial3({});}
  };

  const MapCLFinal = (checked: boolean) => {
      setTableDataCLFinal(checked);
      if(checked) { 
        const CLFinal = mapRxData(examData, Number(Code.Exam.Map.CLFINAL)); 
        setClFinal(CLFinal);
      } else { setClFinal({});}
  };
  

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={Code.Form.Name.PRESCRIPTION} Privilege={Privilege}  clientData={clientData} fileName='exam' docType={Code.Option.DocumentType.PRESCRIPTION} printRef={printRef} showModify={false} setMessage={setMessage} setError={setError}>
          <Control.Form.CheckList title='Rx Options'>
              <Control.Form.CheckBox title='Final Rx 1' fieldName={tableDataFinalRx1} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FINALRX} />
              <Control.Form.CheckBox title='Final Rx 2' fieldName={tableDataFinalRx2} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FINALRX2} />
              <Control.Form.CheckBox title='Final Rx 3' fieldName={tableDataFinalRx3} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FINALRX3} />
              <Control.Form.CheckBox title='Medication' fieldName={tableDataMedication} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.MEDICATION} />
              <Control.Form.CheckBox title='CL Trial 1' fieldName={tableDataCLTrial1} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.CLTRAIL1} />
              <Control.Form.CheckBox title='CL Trial 2' fieldName={tableDataCLTrial2} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.CLTRAIL2} />
              <Control.Form.CheckBox title='CL Trial 3' fieldName={tableDataCLTrial3} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.CLTRAIL3} />
              <Control.Form.CheckBox title='CL Final' fieldName={tableDataCLFinal} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.CLFINAL} />
          </Control.Form.CheckList>
          <Control.Form.CheckList title='Field Options'>
              <Control.Form.CheckBox title='Client ID' fieldName={fieldClientId} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_CLIENT_ID} />
              <Control.Form.CheckBox title='AHC Number' fieldName={fieldAHC} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_AHC} />
              <Control.Form.CheckBox title='Date of Birth' fieldName={fieldDOB} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_DOB} /> 
              <Control.Form.CheckBox title='Phone' fieldName={fieldPhone} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_PHONE} />
              <Control.Form.CheckBox title='Address' fieldName={fieldAddress} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_ADDRESS} />
              <Control.Form.CheckBox title='Dispenser' fieldName={fieldDispenser} handleCheckChange={handleCheckChange} rxId={Code.Exam.Map.FIELD_DISPENSER} />
          </Control.Form.CheckList>
        </Button.Print>
        <Control.Print.Data ref={printRef}>
          <Control.Flex>
            <Control.Column size={[0,60,0,0]}>
              <Control.Box>
                <Field.CompanyHead companyId={companyId} locationId={locationId} />
              </Control.Box>
              <Control.Box>
                <Field.Value value={Utility.Get.FullName(clientData, Code.Form.Name.CLIENT).toUpperCase()} valueBold={true} />
                {fieldPhone && <Field.Value value={Utility.Format.Phone(clientData?.client_phone)} />}
                {fieldAddress && <> 
                  <Field.Value value={clientData?.client_address || ''} />
                  <Field.Value value={`${clientData?.city_name || ''} ${clientData?.client_postal?.toUpperCase() || ''}`} /> 
                </>}
              </Control.Box>
            </Control.Column>
            <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
              <Control.Box>
                <Field.SubHead title={Code.Form.Name.PRESCRIPTION} />
                <Control.Form.Barcode value={formData.exam_number!} />       
                <Field.Value title={Title.SNo} value={formData.exam_number} />
                <Field.Value title={Title.Date} value={Utility.Format.DateOnly(formData.exam_date)} />
                <Field.Value title={Title.Doctor} value={Utility.Get.FullName(doctorData,Code.Form.Name.DOCTOR)} />
                {fieldDispenser && <Field.Value title={Title.Dispenser} value={Utility.Get.FullName(userData,Code.Form.Name.USER)} />}
                {fieldClientId && <Field.Value title={Title.ClientId} value={`#${clientData?.client_number}`} />}
                {fieldAHC && <Field.Value title={Title.HealthCard} value={clientData?.client_health_card} />}
                {fieldDOB && <Field.Value title={Title.ClientDOB} value={Utility.Format.DateOnly(clientData?.client_dob)} />}
              </Control.Box>
            </Control.Column>
          </Control.Flex>
          <Control.Box>
              {tableDataFinalRx1 ? (<Control.Html.Prescription prescriptionData={finalRx1} classname='pt4 pb4' />) : null } 
              {tableDataFinalRx2 ? (<Control.Html.Prescription prescriptionData={finalRx2} classname='pt4 pb4' />) : null } 
              {tableDataFinalRx3 ? (<Control.Html.Prescription prescriptionData={finalRx3} classname='pt4 pb4' />) : null } 
              {tableDataMedication ? (<Control.Html.Medication medicationData={medication} classname='pt4 pb4' />) : null } 
              {tableDataCLTrial1 ? (<Control.Html.PrescriptionCL prescriptionCL={clTrial1} classname='pt4 pb4' />) : null } 
              {tableDataCLTrial2 ? (<Control.Html.PrescriptionCL prescriptionCL={clTrial2} classname='pt4 pb4' />) : null } 
              {tableDataCLTrial3 ? (<Control.Html.PrescriptionCL prescriptionCL={clTrial3} classname='pt4 pb4' />) : null } 
              {tableDataCLFinal ? (<Control.Html.PrescriptionCL prescriptionCL={clFinal} classname='pt4 pb4' />) : null } 
              {(tableDataFinalRx1 || tableDataFinalRx2 || tableDataFinalRx3) && <div className='ptremarks fs14 fwb pt2 pb6'>* This prescription expires on {Utility.Format.DateOnly(expiryDate)}</div> }
                  
          </Control.Box>
          <Control.Flex>
            <Control.Column size={[0,65,0,0]}>
              <Control.Box>
               {(tableDataFinalRx1 || tableDataFinalRx2 || tableDataFinalRx3) &&  <Control.Print.Term value={termData} /> }
              </Control.Box>
            </Control.Column>
            <Control.Column size={[0,10,0,0]}><></></Control.Column>
            <Control.Column size={[0,25,0,0]} align={Code.Align.RIGHT}>
              <Field.DoctorSignature doctorId={formData.doctor_id} />
            </Control.Column>
          </Control.Flex>
          {/* <div className="page-number" /> */}
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
      <Field.PrintedOn fixed={false} />
    </Control.Print.Frame>
  );
};

export default ExamPrint;